import React from 'react';
import { motion } from 'framer-motion';
const situations = [{
  emoji: '😰',
  title: 'El "Efecto Pantalla"',
  desc: 'Sabés que 15 días pegado al celular o la tablet van a borrar meses de esfuerzo escolar, pero no encontrás una alternativa que realmente funcione.'
}, {
  emoji: '🍃',
  title: 'El Retroceso Silencioso',
  desc: 'En agosto tu hijo llega al aula y los temas de matemática y lectura que había entendido en junio ya no los recuerda. Y recuperar ese terreno cuesta el doble.'
}, {
  emoji: '📱',
  title: 'La Culpa del Padre Moderno',
  desc: 'Querés que descanse, pero también querés que no pierda el ritmo. No sabés cómo equilibrar vacaciones reales con algo productivo sin convertirte en su maestro particular.'
}, {
  emoji: '😩',
  title: 'El Agotamiento de Inventar Actividades',
  desc: 'Buscás en Pinterest, en grupos de WhatsApp, en Instagram. Encontrás mil cosas sueltas que no tienen estructura ni conexión entre sí y terminás sin usar nada.'
}];
export function ProblemSection() {
  return <section className="py-12 md:py-16 bg-transparent" data-id="element-151">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-152">
        <div className="text-center mb-10" data-id="element-153">
          <h2 className="font-heading text-3xl md:text-5xl font-bold mb-4 text-[#2f3a2c]" data-id="element-154">
            ¿TE RECONOCES EN ESTO?
          </h2>
          <p className="text-xl font-bold text-[#6f7a64] mb-4 italic" data-id="element-155">
            ¿Amás a tu hijo, pero las vacaciones de invierno te generan más
            angustia que alivio?
          </p>
          <p className="text-lg text-slate-600 leading-relaxed max-w-2xl mx-auto" data-id="element-156">
            Si sos mamá o papá de un nene de 5to grado, seguramente conocés
            alguna de estas situaciones:
          </p>
        </div>

        <div className="grid sm:grid-cols-2 gap-6" data-id="element-157">
          {situations.map((item, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-white p-6 rounded-2xl shadow-sm border border-slate-200" data-id="element-158">
              <div className="text-3xl mb-3" data-id="element-159">{item.emoji}</div>
              <h3 className="text-lg font-bold text-[#2f3a2c] mb-2" data-id="element-160">
                {item.title}
              </h3>
              <p className="text-slate-600 leading-relaxed" data-id="element-161">{item.desc}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}